import '../css/live-search.css'

function pdlDebounce(func, wait, immediate) {
        let timeout;
        return function() {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        }
}

let liveSearchRequest;

let liveSearchFunction = pdlDebounce(function() {
    let searchTerm = document.getElementById('s').value
    jQuery('#live-search .error').text('').hide()
    if (searchTerm.length < 3) {
        document.getElementById('live-search').classList.remove('active')
        return false
    }
    if (liveSearchRequest && liveSearchRequest.readystate != 4) {
        lsxhr.abort()
    }

    jQuery('#live-search .product-grid').html('')
    document.getElementById('live-search').classList.add('active')
    jQuery('#live-search .loading').show()

    liveSearchRequest = jQuery.ajax('/shop/ajax', {
        data: { nowp: 1, action: 'searchGrid', sort: 'relevance', q: searchTerm }
    }).done(function (data) {
        jQuery('#live-search .product-grid').html(data)
        jQuery('#live-search .loading').hide()
        liveSearchRequest = false
    }).fail(function() {
        jQuery('#live-search .error').text('Sorry, it looks like something went wrong. Please refresh the page and try again.').show()
        liveSearchRequest = false
    })

    console.log(`searching for ${searchTerm}`)
}, 300)

document.getElementById('close-live-search').addEventListener('click', () => {
    document.getElementById('live-search').classList.remove('active')
    document.getElementById('s').value = ''
})

document.getElementById('s').addEventListener('keyup', liveSearchFunction);
